import styled from "styled-components";
import { COLOUR_CONSTANT } from "../../utils/contants";

export const TimetrackerStyled = styled.div`
  .header {
    .info {
      display: flex;
      justify-content: space-between;
      margin: 10px 36px;
      border-bottom: 1px solid ${COLOUR_CONSTANT.theme.purple.medium};
    }
  }
  .info {
    display: flex;
    justify-content: space-between;
    padding-top: 15px;
  }

  .viewing {
    display: flex;
    gap: 5px;
    align-items: center;
  }

  .timesheet {
    height: calc(100vh - 187px);
    overflow-y: auto;
  }
`;
